import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MultiselectDropdownModule } from "angular-2-dropdown-multiselect";
import { NgxPaginationModule } from "ngx-pagination";
import { PipesModule } from "../../theme/pipes/pipes.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { CommonHttpService } from "src/app/common.service";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { MaskedTextBoxModule } from "@syncfusion/ej2-angular-inputs";
import {
  ColumnChooserService,
  FilterService,
  GridModule,
  PageService,
  ResizeService,
  SortService,
} from "@syncfusion/ej2-angular-grids";
import { CareCoordinatorComponent } from "./care-coordinator.component";
import { CareCoordinatorRoutingModule } from "./care-coordinator-routing.module";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    MultiselectDropdownModule,
    NgxPaginationModule,
    PipesModule,
    GridModule,
    NgSelectModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    CareCoordinatorRoutingModule
  ],
  declarations: [CareCoordinatorComponent],

  providers: [
    CommonHttpService,
    ColumnChooserService,
    PageService,
    SortService,
    FilterService,
    ResizeService,
  ],
})
export class CareCoordinatorModule { }
